import React, { useEffect, useRef } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import { Table } from 'rsuite';
import { useState } from 'react';
import ProjectProp from '../../Components/Project/ProjectProp';
import * as General from '../../General/General';
import axios from 'axios';
import { FaUser } from "react-icons/fa";
import {isMobile} from 'react-device-detect';
import Delete from '../../Components/Shared/Delete';
import * as Enum from '../../General/Enum';
import ResponsiveList, { CardTitle, CardActions } from '../../Components/Shared/ResponsiveList';
import { useNavigate } from 'react-router-dom';
import { BiSolidCategory } from "react-icons/bi";
import RowHeight from '../../Components/Shared/RowHeight';

const { Column, HeaderCell, Cell } = Table;



const Index = () => {

    //#region Const

    let navigate=useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [showDrawer, setShowDrawer] = useState(false);
    const [ShowLoader, setShowLoader] = useState(true);
    const [List, setList] = useState([]);
    const ref=useRef();
    const DeleteRef=useRef();
    const PopupRef=useRef();
    //#endregion


    
    
    const ShowDelete = (Id) => {
        if (PopupRef.current) { PopupRef.current.close(); }
        DeleteRef.current.Show(Enum.DeleteType.Project,Id);
    }
    const handleProp = (Id) => {
        if (isMobile) {
            setShowDrawer(true);
        } else {
            setShowModal(true);
            
        }
        setTimeout(() => {
                ref.current.ShowEdit(Id);
            }, 500);
            if (PopupRef.current) { PopupRef.current.close(); }
    };

    const Bind = () => {
        var RequestOption = {
            method: "Get",
            url: General.ApiRoute() + "/Project/GetAll",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
            },
             withCredentials: true
        }
        axios(RequestOption)
            .then(function (res) {
                if (res.data.length > 0) {
                    setList(res.data);
                }
                setShowLoader(false)
            })

            .catch(error=>{
                if (error.response)
                {
                    if (error.response.status===401)
                    {
                        navigate("/UnAuthorize")
                    }
                    else if (error.response.status===403)
                    {
                        navigate("/AccessDenied")
                    } 
                }
                else
                {
                    General.ShowMsg(Enum.MsgType.error,General.UnkownException(error));
                    setShowLoader(false);
                }
            })
    }

    useEffect(() => {
        Bind();
    }, [])

    return (
        <Shared pageTitle={<><BiSolidCategory size={25} /> دسته بندی پروژه ها</>}>
            <div align="left">
                <rsuite.Button appearance="primary" className="mb-2" onClick={()=>handleProp(General.GuidEmpty())}>
                    ایجاد پروژه جدید
                </rsuite.Button>

            </div>
            <rsuite.Divider />
            <ResponsiveList
                fillHeight
                data={List}
                loading={ShowLoader}
                emptyText="پروژه ای ثبت نشده است"
                filters={[
                    { key: 'title', label: 'عنوان', type: 'text' }
                ]}
                renderCard={(rowData) => (
                    <>
                        <CardTitle>{rowData.title}</CardTitle>
                        <CardActions>
                            <rsuite.Button size="sm" onClick={() => handleProp(rowData.id)}>ویرایش</rsuite.Button>
                            <rsuite.Button size="sm" appearance="primary" color="red" className='ms-2'
                                onClick={() => ShowDelete(rowData.id)}>حذف</rsuite.Button>
                        </CardActions>
                    </>
                )}
            >
                <Table
                    rtl={true}
                    className='w-100'
                    bordered
                    headerHeight={40}
                    rowHeight={RowHeight}
                    wordWrap="break-word"
                    data={List}
                    loading={ShowLoader}
                    onRowClick={(e) => console.dir(e)}

                >

                    <Column flexGrow={1}>
                        <HeaderCell ><b>ردیف</b></HeaderCell>
                        <General.RowNumber />
                    </Column>

                    <Column flexGrow={5} sortable>
                        <HeaderCell><b>عنوان</b></HeaderCell>
                        <Cell dataKey="title" />
                    </Column>
             

                    <Column fixed="right" className='Popup'>
                        <HeaderCell>عملیات</HeaderCell>
                        <Cell >
                            {rowData => (
                                <rsuite.Whisper
                                    placement="bottomStart"
                                    controlId="control-id-with-dropdown"
                                    trigger="click"
                                    ref={PopupRef}
                                    speaker={
                                        <rsuite.Popover  full>
                                            <rsuite.Dropdown.Menu >
                                                <rsuite.Dropdown.Item onClick={() => handleProp(rowData.id)}>ویرایش</rsuite.Dropdown.Item>
                                                <rsuite.Dropdown.Item onClick={() => ShowDelete(rowData.id)}>حذف</rsuite.Dropdown.Item>
                                            </rsuite.Dropdown.Menu>
                                        </rsuite.Popover>
                                    }
                                >
                                    <rsuite.Button>...</rsuite.Button>
                                </rsuite.Whisper>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </ResponsiveList>




            <rsuite.Modal open={showModal} onClose={() => setShowModal(false)} size="md">
                <rsuite.Modal.Header>
                    <rsuite.Modal.Title>مشخصات پروژه</rsuite.Modal.Title>
                </rsuite.Modal.Header>
                <rsuite.Modal.Body>
                    <ProjectProp ref={ref} onSubmit={() => (setShowModal(false), Bind())} />
                </rsuite.Modal.Body>
            </rsuite.Modal>
            <rsuite.Drawer open={showDrawer} onClose={() => setShowDrawer(false)} placement="right" size="xs">
                <rsuite.Drawer.Header>
                    <rsuite.Drawer.Title>مشخصات پروژه</rsuite.Drawer.Title>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <ProjectProp ref={ref} onSubmit={() => (setShowModal(false), Bind())} />
                </rsuite.Drawer.Body>
            </rsuite.Drawer>
            <Delete ref={DeleteRef} onSubmit={Bind}/>
        </Shared>
    );



}

export default Index;
